{
  "titles": {
    "appointmentDetailsHaveChanged": "Les détails du rendez-vous ont changé",
    "appointmentScheduled": "Rendez-vous planifié",
    "appointmentConfirmed": "Rendez-vous confirmé",
    "appointmentRequested": "Rendez-vous demandé",
    "missedAppointment": "Rendez-vous manqué",
    "recurringAppointmentSeriesCreated": "Série de rendez-vous récurrents créée",
    "truckArrivedAtFacility": "Camion arrivé à l’installation",
    "appointmentIsInProgressAtFacility": "Rendez-vous en cours à l’installation",
    "appointmentRescheduled": "Rendez-vous replanifié",
    "appointmentCompleted": "Rendez-vous terminé",
    "appointmentCancelled": "Rendez-vous annulé",
    "appointmentTagged": "Rendez-vous étiqueté",
    "assetReadyForPickup": "Actif prêt pour la collecte"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "Les détails du rendez-vous ont changé",
    "appointmentScheduled": "Rendez-vous planifié chez {orgName} - {warehouseName}",
    "appointmentConfirmed": "Rendez-vous confirmé chez {orgName} - {warehouseName}",
    "appointmentRequested": "Rendez-vous demandé chez {orgName} - {warehouseName}",
    "missedAppointment": "Rendez-vous manqué chez {orgName} - {warehouseName}",
    "recurringAppointmentSeriesCreated": "Une série de rendez-vous récurrents a été créée",
    "truckArrivedAtFacility": "Camion arrivé chez {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "Rendez-vous en cours chez {orgName} - {warehouseName}",
    "appointmentRescheduled": "Rendez-vous replanifié chez {orgName} - {warehouseName}",
    "appointmentCompleted": "Rendez-vous terminé chez {orgName} - {warehouseName}",
    "appointmentCancelled": "Rendez-vous annulé avec {orgName} - {warehouseName}",
    "appointmentTagged": "Rendez-vous étiqueté comme {tagName} - {warehouseName}",
    "assetReadyForPickup": "Prêt pour la collecte - Conteneur {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "Veuillez vérifier l’emplacement, la date, l’heure et tous les détails ci-dessous.",
    "appointmentScheduled": "Veuillez vérifier l’emplacement, la date, l’heure et tous les détails ci-dessous.",
    "appointmentConfirmed": "Veuillez vérifier l’emplacement, la date, l’heure et tous les détails ci-dessous.",
    "appointmentRequested": "Veuillez attendre la confirmation de l’entrepôt.",
    "missedAppointment": "Le transporteur ne s’est pas présenté au rendez-vous.",
    "recurringAppointmentSeriesCreated": "Veuillez vérifier les détails du rendez-vous récurrent ci-dessous.",
    "truckArrivedAtFacility": "Vérifiez le statut et les détails du rendez-vous ci-dessous.",
    "appointmentIsInProgressAtFacility": "Vérifiez le statut et les détails du rendez-vous ci-dessous.",
    "appointmentRescheduled": "Vérifiez le statut et les détails du rendez-vous ci-dessous.",
    "appointmentCompleted": "Vérifiez le statut et les détails du rendez-vous ci-dessous.",
    "appointmentCancelled": "Veuillez vérifier tous les détails et la raison de l’annulation.",
    "appointmentTagged": "Veuillez vérifier le nom de l’étiquette et les informations ci-dessous.",
    "assetReadyForPickup": "Un actif dans votre installation est prêt pour la collecte."
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "Voir le rendez-vous",
    "appointmentScheduled": "Voir le rendez-vous",
    "appointmentConfirmed": "Voir le rendez-vous",
    "appointmentRequested": "Voir le rendez-vous",
    "missedAppointment": "Voir le rendez-vous",
    "recurringAppointmentSeriesCreated": "Voir le rendez-vous original",
    "truckArrivedAtFacility": "Voir le rendez-vous",
    "appointmentIsInProgressAtFacility": "Voir le rendez-vous",
    "appointmentRescheduled": "Voir le rendez-vous",
    "appointmentCompleted": "Voir le rendez-vous",
    "appointmentCancelled": "Voir le rendez-vous",
    "appointmentTagged": "Voir le rendez-vous",
    "assetReadyForPickup": "Voir le rendez-vous"
  },
  "descriptions": {
    "appointmentTagged": "Utilisez le paramètre d’étiquettes de rendez-vous pour les activer individuellement"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "Planifier la collecte",
      "idLabel": "Numéro de confirmation",
      "ownedByLabel": "Propriétaire :",
      "pickupScheduledForLabel": "Collecte prévue pour :",
      "noPickupScheduledLabel": "Aucun rendez-vous de collecte programmé",
      "storeLabel": "Magasin",
      "openInGoogleMapsLabel": "Ouvrir dans Google Maps",
      "appointmentDetailsLabel": "Détails du rendez-vous",
      "loadTypeLabel": "Type de chargement",
      "warehouseInstructionsLabel": "Instructions de l’entrepôt",
      "amenitiesLabel": "Commodités disponibles",
      "ppeRequirementsLabel": "EPI et autres exigences",
      "dockDoorLabel": "Porte de quai",
      "dockInstructionsLabel": "Instructions du quai",
      "carrierContactLabel": "Contact du transporteur"
    }
  }
}
